module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_html.js
// module id = 833
// module chunks = 0